<template lang="pug">
  base-side-nav(:items='menuItems')
</template>

<script>
import BaseSideNav from "@/shared/components/BaseSideNav";

export default {
  components: { BaseSideNav },
  data() {
    return {
      menuItems: [
        {
          label: "Dashboard",
          icon: "home",
          routeName: "brapp:dashboard",
          subNav: []
        },
        {
          label: "Briefs",
          icon: "file",
          permission: { type: "briefs", can: "view" },
          subNav: [
            { label: "All Briefs", routeName: "briefList" },
            {
              label: "Create Brief",
              routeName: "briefCreate",
              permission: { type: "briefs", can: "add" }
            }
          ]
        },
        {
          label: "Alerts",
          icon: "bell",
          permission: { type: "alerts", can: "view" },
          subNav: [
            { label: "All Alerts", routeName: "alertList" },
            {
              label: "Create Alert",
              routeName: "alertCreate",
              permission: { type: "alerts", can: "add" }
            }
          ]
        },
        {
          label: "Reports",
          icon: "flag",
          permission: { type: "flags", can: "view" },
          subNav: [
            { label: "Report Overview", routeName: "issueOverview" },
            { label: "Report List", routeName: "issueList" },
            {
              label: "Manage Report Types",
              routeName: "issueTypes",
              permission: { type: "flags", can: "add" }
            }
          ]
        },
        {
          label: "Sales",
          icon: "shopping-basket",
          subNav: [
            { label: "Sales Overview", routeName: "brapp:sales:overview" },
            { label: "Product list", routeName: "brapp:sales:productList" },
            {
              label: "Manage Locations",
              routeName: "brapp:sales:locationList"
            },
            {
              label: "Manage Categories",
              routeName: "brapp:sales:categoryList"
            }
          ]
        },
        {
          label: "Recognise",
          icon: "comments",
          permission: { type: "recognise", can: "view" },
          subNav: [
            { label: "Recognise Overview", routeName: "recognitionOverview" },
            { label: "Recognise List", routeName: "recognitionList" }
          ]
        }
      ]
    };
  }
};
</script>

<style scoped lang="scss"></style>
